import React, { useEffect, useState } from "react";
import useSize from "../../../../Utils/useSize/useSize";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Loading from "../../../../Utils/Loading/Loading";
import { VirtualScroller } from "primereact/virtualscroller";
import useSound from "use-sound";
import Error from "../../../../Sound/Error.wav";
import NotFound from "../../../../Utils/NotFound/NotFound";
import RulesCard from "./RulesCard";
import TopCard from "./TopCard/TopCard";

const backend = await new Backend().init();

export default function SymbolRejection() {
  const [play] = useSound(Error);
  const windowSize = useSize();

  const userType = Number(localStorage.getItem("user_type") || 7);

  const [rules, setRules] = useState([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadRules();
  }, []);

  const loadRules = (a, b) => {
    setLoading(true);
    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
    };

    backend.rules(data).then((r) => {
      setLoading(false);
      if (r.error == "False") {
        setRules(r.rules);
      } else {
        ErrorSound();
        toast.error(r.message);
      }
    });
  };

  const ErrorSound = () => {
    play();
  };

  return (
    <div
      key={rules}
      style={{
        width: windowSize[0],
        height: windowSize[1] - 110,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {userType === 1 && <TopCard reload={loadRules} userType={userType} />}

      {loading ? (
        <div className="loadingContainer">
          <Loading height={windowSize[1] - 110} />
        </div>
      ) : rules.length > 0 ? (
        <VirtualScroller
          style={{
            width: windowSize[0],
            height: windowSize[1] - 150,
          }}
          items={rules}
          itemSize={50}
          itemTemplate={(item, index) => {
            return (
              <RulesCard
                userType={userType}
                key={item.id}
                index={index}
                item={item}
                reload={loadRules}
              />
            );
          }}
        />
      ) : (
        <NotFound height={windowSize[1] - 150} title={"Nothing here"} subtext={"No Rules Found."} />
      )}
    </div>
  );
}
